export default __webpack_public_path__ + "static/santiago_santos@2x-df13759ec91da577862a6d0550c151c7.jpeg";